const BD_ENRICH_SPRING_ENDPOINT = process.env.BD_ENRICH_SPRING_ENDPOINT;
const ENRICH_SPRING_ENDPOINT = process.env.ENRICH_SPRING_ENDPOINT;
const MATCH_SPRING_ENDPOINT = process.env.MATCH_SPRING_ENDPOINT;
const BD_MATCH_SPRING_ENDPOINT = process.env.BD_MATCH_SPRING_ENDPOINT;

const BD_SCHEDULER_SPRING_ENDPOINT = process.env.BD_SCHEDULER_SPRING_ENDPOINT;

const NODE_ENDPOINT = process.env.API_URL + ':' + process.env.API_PORT;
const CHAT_BOT_URL = process.env.CHAT_BOT_URL;

module.exports = {
    user: {
        logout: '/api/recon/entitlements/user/logout',
        login: NODE_ENDPOINT + '/api/recon/entitlements/login',
        register: '/api/recon/entitlements/register',
        user: '/api/recon/entitlements/user',
        status: '/api/recon/entitlements/user/status',
        users: '/api/recon/entitlements/users',
        profileInfo: '/api/recon/entitlements/user/profileinfo',
        location: '/api/recon/entitlements/user/location',
        root: '/api/recon/entitlements/user',
        registerUser: '/api/recon/entitlements/user/registration',
        roles: '/api/recon/entitlements/user/role',
        roleUpdate: '/api/recon/entitlements/user/role-update',
        applications: '/api/recon/entitlements/user/applicationDashboard',
        dashboards: '/api/recon/entitlements/user/dashboard',
        routes: '/api/recon/entitlements/user/dashboard-routes',
        authorization: '/api/recon/entitlements/user/authorization',
        delete: '/api/recon/entitlements/user/delete',
        userUpdate: '/api/recon/entitlements/user/user-update',
        userUpdatePassword: '/api/recon/entitlements/user/user-update-password',
        details: '/api/recon/entitlements/user/details',
        screenPermissions: '/api/recon/entitlements/user/screen-permissions',
        ssAccessToken: '/api/recon/entitlements/user/super-set-access-token',
        userLogs: '/api/recon/entitlements/user/user-logs',
        supersetLink: '/api/recon/entitlements/user/super-set-link',
        checkPermission: '/api/recon/entitlements/user/check-permission',
    },
    componentFolders: {
        folders: '/api/recon/entitlements/component/folders',
        folderItems: '/api/recon/entitlements/component/folder-items',
        assignItems: '/api/recon/entitlements/component/folder-items/assign',
        moveItem: '/api/recon/entitlements/component/folder-items/move',
        ensureDefaults: '/api/recon/entitlements/component/folders/ensure-defaults',
        saveSharing: '/api/recon/entitlements/component/folder-items/save-sharing',
    },
    sharedComponents: '/api/recon/entitlements/shared-components',
    configuration: {
        sourceConfiguration: '/api/recon/source-configuration',
        viewConfiguration: '/api/recon/view-configuration',
        dynamicViewConfiguration: '/api/recon/view-configuration/dynamic',
        viewFieldMap: '/api/recon/view-field-map',
        dataDictionary: '/api/recon/data-dictionary',
        reconConfiguration: '/api/recon/recon-configuration',
        matchingTypes: '/api/recon/default/st-rules',
        filters: '/api/recon/default/st-filters',
        matchingConditions: '/api/recon/default/st-matching-conditions',
        bdMatchingConditions: '/api/recon/default/ref-data-matching-conditions',
        fixedConditions: '/api/recon/default/st-fixed-conditions',
        bdFixedConditions: '/api/recon/default/ref-data-fixed-conditions',
        matchStatus: '/api/recon/default/st-recon-match-status-filter',
        appRoutes: '/api/recon/default/st-app-routes',
        applicationDashboard: '/api/recon/default/application-dashboard',
    },
    refData: {
        groupSetup: '/api/reference-data/group-setup',
        groupSettings: '/api/reference-data/group-settings',
        groupLock: '/api/reference-data/group-lock',
        dataDictionary: '/api/reference-data/data-dictionary',
        importDD: '/api/reference-data/data-dictionary/setup/dd-import',
        importRawDD: '/api/reference-data/data-dictionary/setup/dd-import-raw',
        matchingRules: '/api/reference-data/matching-rules',
        allMatchingRules: '/api/reference-data/all-matching-rules',
        matchingRuleNames: '/api/reference-data/matching-rules/name',
        predictRules: '/api/reference-data/predict-rules',
        imageExtract: '/api/reference-data/image-extract',
        apiChatBot: '/api/reference-data/default/chat',
        apiRaiseIssue: '/api/reference-data/default/raise-issue',
        mappingMatchings: '/api/reference-data/mapping/matching-rules',
        groupConfiguration: '/api/reference-data/group-configuration',
        sourceConfiguration: '/api/reference-data/source-configuration',
        sourceFieldMappings: '/api/reference-data/source-configuration/field-mappings',
        groupSourceFieldMappings: '/api/reference-data/group/source-fields/mappings',
        groupSourceNameMappings: '/api/reference-data/group/source-names/mappings',
        linkGroupFieldMappings: '/api/reference-data/group/field-linking/mapping',
        blocDataExplorerSchemas: '/api/reference-data/blocdata-explorer/schemas',
        refDataGoldenCopySchemas: '/api/reference-data/refdatagoldencopy-explorer/schemas',
        refDataGoldenCopyExplorerRecords: '/api/reference-data/refdatagoldencopy-explorer/records',
        refDataGoldenCopyExplorerRecordsByClientId: '/api/reference-data/refdatagoldencopy-explorer/recordsbyclientid',
        blocDataExplorerRecords: '/api/reference-data/blocdata-explorer/records',
        sourceDataExplorerRecords: '/api/reference-data/blocdata-explorer/source-data',
        blocDataExplorerDeleteRecord: '/api/reference-data/blocdata-explorer/delete',
        blocDataExplorerUpdateRecord: '/api/reference-data/blocdata-explorer/update',
        blocDataExplorerCreateRecord: '/api/reference-data/blocdata-explorer/create',
        goldenCopyExplorerCreateRecord: '/api/reference-data/blocdata-explorer/golden-copy-create',
        mergeGoldenCopyExplorerRecord: '/api/reference-data/blocdata-explorer/merge-gc',
        markAsIgnored: '/api/reference-data/blocdata-explorer/mark-as-ignored',
        blocDataExplorerfilterByCreatedDate: '/api/reference-data/blocdata-explorer/filterDate',
        blocDataExplorerImport: '/api/reference-data/blocdata-explorer/import',
        linkedGroupRecords: '/api/reference-data/blocdata-explorer/linked-group-records',
        linkedGcData: '/api/reference-data/blocdata-explorer/linked-gc-data',
        tradeStatus: '/api/reference-data/trade-status',
        dataImports: '/api/reference-data/data-imports',
        xsdTemplate: '/api/reference-data/xsd-template',
        report: '/api/reference-data/report',
        reportFields: '/api/reference-data/reportFields',
        createReportConfig: '/api/reference-data/create-report-config',
        deleteReport: '/api/reference-data/delete-report',
        reportreconfieldexpressions: '/api/reference-data/report-expressions',
        newReportFields: '/api/reference-data/reportfields-mappings',
        reportreconfieldmaps: '/api/reference-data/reportreconfieldmaps',
        reportSchedulers: '/api/reference-data/report-schedulers',
        validateQueryExpression: '/api/reference-data/calculation-expression-validation',
        sqlQueryExpression: '/api/reference-data/sqlQueryExpression',
        reportDDFields: '/api/reference-data/report-dd-fields',
        copyReport: '/api/reference-data/copy-report',
        refGroupSourceNameMappings: '/api/reference-data/name/mappings',
        refGroupSourceFieldMappings: '/api/reference-data/group-source-field-mappings',
        refGroupSqlQueryExpression: '/api/reference-data/group-source-field-mappings/sql-expression',
        refGroupValidateExpression: '/api/reference-data/group-source-field-mappings/calculation-expression-validation',
        lookUpExpression: '/api/reference-data/group-source-field-mappings/lookup-expression',
        sourceMapping: '/api/reference-data/group-source-field-mappings/source-mapping',
        importMappingSetup: '/api/reference-data/group-source-field-mappings/import',
        activeMappingSetup: '/api/reference-data/group-source-field-mappings/active',
        configImportGroupPreview: '/api/reference-data/config-import/group/preview',
        configImportGroupConfirm: '/api/reference-data/config-import/group/confirm',
        configImportSourcePreview: '/api/reference-data/config-import/source/preview',
        configImportSourceConfirm: '/api/reference-data/config-import/source/confirm',
        configImportGroupSourceMapPreview: '/api/reference-data/config-import/group-source-map/preview',
        configImportGroupSourceMapConfirm: '/api/reference-data/config-import/group-source-map/confirm',
        configImportDataImportsPreview: '/api/reference-data/config-import/data-setup-import/preview',
        configImportDataImportsConfirm: '/api/reference-data/config-import/data-setup-import/confirm',
        configImportReportPreview: '/api/reference-data/config-import/report/preview',
        configImportReportConfirm: '/api/reference-data/config-import/report/confirm',
        configImportMatchingRulePreview: '/api/reference-data/config-import/matching-rule/preview',
        configImportMatchingRuleConfirm: '/api/reference-data/config-import/matching-rule/confirm',
        configImportEventSetupPreview: '/api/reference-data/config-import/event-setup/preview',
        configImportEventSetupConfirm: '/api/reference-data/config-import/event-setup/confirm',
        filters: '/api/reference-data/group-source-filters',
        sourceSummaryData: 'api/reference-data/blocdata-explorer/source-summary-data',
        history: '/api/reference-data/blocdata-explorer/history',
        uniqueGcId: '/api/reference-data/blocdata-explorer/unique-gc-id',
        dataLineage: '/api/reference-data/blocdata-explorer/data-lineage',
        gcHistoricData: '/api/reference-data/blocdata-explorer/gc-historic',
        linkedGroups: '/api/reference-data/blocdata-explorer/linked-groups',
        linkedDDData: '/api/reference-data/blocdata-explorer/linked-dd-data',
        duplicateDetectionFields: '/api/reference-data/blocdata-explorer/duplicate-detection-fields',
        duplicateCondition: '/api/reference-data/blocdata-explorer/duplicate-condition',
        duplicateConditions: '/api/reference-data/blocdata-explorer/duplicate-conditions',
        mergeAudit: '/api/reference-data/blocdata-explorer/merge-audit',
        sourceData: '/api/reference-data/blocdata-explorer/source-matches',
        previousData: '/api/reference-data/blocdata-explorer/previous-versions',
        createChangeHistoryView: '/api/reference-data/blocdata-explorer/create-change-history-view',
        sourceContribution: '/api/reference-data/blocdata-explorer/source-contribution',
        enrichments: '/api/reference-data/enrichments',
        purge: '/api/reference-data/purge',
        enrichValidate: '/api/reference-data/enrich-validate',
        enrichConfig: '/api/reference-data/enrich-config',
        purgeConfig: '/api/reference-data/purge-config',
        event: '/api/reference-data/event-setup',
        triggerEvent: '/api/reference-data/trigger-event',
        eventProcess: '/api/reference-data/event-process',
        eventProcessOrder: '/api/reference-data/event-process-order',
        eventMonitoring: '/api/reference-data/event-monitoring',
        eventMonitoringRulesLock: '/api/recon/recon-explorer/event-monitoring/import-rules-lock',
        eventMonitoringFileDetails: '/api/recon/recon-explorer/event-monitoring/import-file-details',
        eventMonitoringBatchDetails: '/api/recon/recon-explorer/event-monitoring/import-batch-details',
        processEventBatchFiles: '/api/recon/recon-explorer/event-monitoring/process-import-batch-details',
        views: '/api/reference-data/views',
        getGcTables: '/api/reference-data/get-gc-tables',
        viewData: '/api/reference-data/views-data',
        viewColumns: '/api/reference-data/view-columns',
        gcScreenLayout: '/api/reference-data/gc-screen-layout',
        goldenCopyRuleName: '/api/reference-data/group/golden-copy/rule-name',
        connectionDetails: '/api/reference-data/connection-details',
        serverFolders: '/api/reference-data/server-folders',
        bdDefaultConfigs: '/api/reference-data/default/dropdowns',
        validation: '/api/reference-data/validation-setup',
        tradesChartData: '/api/reference-data/refdatagoldencopy-explorer/trades-chart',
        gcUpdate: '/api/reference-data/blocdata-explorer/gc-update',
        auth: '/api/reference-data/blocdata-explorer/auth',
        sourceComments: '/api/reference-data/source-configuration/import-source-comments',
        sourceSettings: '/api/reference-data/source-configuration/settings',
        truncateSourceData: '/api/reference-data/source-configuration/truncate-source-data',
        ddVersions: '/api/reference-data/data-dictionary/versions',
        chatbot: CHAT_BOT_URL + '/nlq',
        chatbotFeedback: CHAT_BOT_URL + '/feedback',
        mergeRecords: '/api/reference-data/blocdata-explorer/merge-records',
        gcRecord: '/api/reference-data/blocdata-explorer/gc-record',
    },
    transactions: {
        brSource: '/api/recon/transactions/br-source',
        brSourceEnRiched: '/api/recon/transactions/br-source-enriched',
        brExceptions: '/api/recon/transactions/br-exceptions',
    },
    sourceConfiguration: {
        fieldMappings: '/api/recon/source-configuration/field-mappings',
        getMappedFieldColumns: '/api/recon/source-configuration/columns',
        settings: '/api/recon/source-configuration/settings',
    },
    dataDictionary: {
        root: '/api/recon/data-dictionary',
        defaultDictionaries: '/api/recon/data-dictionary/default-dictionaries',
    },
    tradeExplorer: {
        root: '/api/recon/trade-explorer',
        attachments: '/api/recon/trade-explorer/attachments',
        status: '/api/recon/trade-explorer/status',
    },
    reconConfiguration: {
        root: '/api/recon/recon-configuration',
        fieldMappings: '/api/recon/recon-configuration/mapping-configuration',
        filters: '/api/recon/recon-configuration/mapping-configuration/filters',
        reconSummary: '/api/recon/recon-configuration/recon-summary',
        reconSummaryTypes: '/api/recon/recon-configuration/recon-summary-records',
    },
    rules: {
        root: '/api/recon/rules',
        appRules: '/api/recon/rules/app-rules',
        defaultMatchingTypes: '/api/recon/rules/matching-types',
        dictionaryColumns: '/api/recon/rules/matching-types',
        matchingRules: '/api/recon/rules/mapping/matching-rules',
    },
    matchingRulesNames: {
        root: '/api/recon/static/matching-rule/name',
        getRuleNames: '/api/recon/static/matching-rule/matching-rule/names',
        updateMatchingRuleProcessingOrder: '/api/recon/static/matching-rule/names/processing-order',
    },
    adjustmentConfiguration: {
        root: '/api/recon/static/adjustment/configuration',
        workflow: '/api/recon/static/adjustment/configuration/workflow',
        workflowConfiguration: '/api/recon/static/adjustment/configuration/workflow-configuration',
    },
    reconSourceNameMappings: '/api/recon-source/name/mappings',
    reconSourceFieldAggregationMappings: '/api/recon-source/name/mappings/aggregation',
    reconSourceFieldMappings: '/api/recon/recon-source-field-mappings',
    reconSourceFieldFilters: '/api/recon/recon-source-field-mappings/calculation-filter',
    validateQueryExpression: '/api/recon/recon-source-field-mappings/calculation-expression-validation',
    sqlQueryExpression: '/api/recon/recon-source-field-mappings/sql-expression',
    lookUpExpression: '/api/recon/recon-source-field-mappings/lookup-expression',
    reconFieldMappings: '/api/recon/recon-setup-configuration',
    copyFieldsFromSource: '/api/recon/recon-setup-configuration/copy-from-source',
    sourceExplorer: {
        root: '/api/recon/source-explorer',
        delete: '/api/recon/source-explorer/delete',
        dashboard: '/api/recon/source-explorer/dashboard',
        filterByDate: '/api/recon/source-explorer/filter/date',
        import: '/api/recon/import-export/source-explorer',
        export: '/api/recon/import-export/source-explorer',
        template: '/api/recon/import-export/template/source-explorer',
        view: '/api/recon/source-explorer/view',
    },
    reconExplorer: {
        root: '/api/recon/recon-explorer/recon-assets',
        totalCountData: '/api/recon/recon-explorer/totalCountData',
        filterByDateAndMatching: '/api/recon/recon-explorer/filter/date-and-matching',
        defaultFilterMatching: '/api/recon/recon-explorer/default/date-and-matching',
        matchedData: '/api/recon/recon-explorer/matched-data',
        updateComments: 'api/recon/recon-explorer/updateComments',
        manualMatching: 'api/recon/recon-explorer/manualMatching',
        matchingAssets: 'api/recon/recon-explorer/matching-assets',
        reconSummaryData: 'api/recon/recon-explorer/recon-summary-data',
        eventMonitoring: 'api/recon/recon-explorer/event-monitoring',
        sourceSummaryData: 'api/recon/recon-explorer/source-summary-data',
        deleteRecon: 'api/recon/recon-explorer/delete-recon-details',
    },
    calculation: {
        root: '/api/recon/calculation',
        filter: '/api/recon/calculation/filter',
    },
    event: {
        root: '/api/recon/event/setup',
    },
    report: {
        root: '/api/recon/report/setup',
        createConfig: '/api/recon/report/createConfig',
        deleteReport: '/api/recon/report/deleteReport',
        reportFields: '/api/recon/report/reportFields',
        newReportFields: '/api/recon/report/reportfields-mappings',
        reportReconMappings: '/api/recon/report/reportReconMappings',
        sqlQueryExpression: '/api/recon/report/sqlQueryExpression',
        reportreconfieldmaps: '/api/recon/report/reportreconfieldmaps',
        reportreconfieldexpressions: '/api/recon/report/reportreconfieldexpressions',
        validateQueryExpression: '/api/recon/report/calculation-expression-validation',
    },
    filters: '/api/recon/recon-source-filters',
    spring: {
        match: {
            triggerEvent: MATCH_SPRING_ENDPOINT + '/engineapi/recon/jobs',
            triggerRefDataEvent: BD_SCHEDULER_SPRING_ENDPOINT + '/api/scheduler/group/jobs',
            adhocEngineSimulate: MATCH_SPRING_ENDPOINT + '/engineapi/simulate',
            refDataEngineSimulate: BD_MATCH_SPRING_ENDPOINT + '/engineapi/simulate',
            executeSummary: MATCH_SPRING_ENDPOINT + '/engineapi/executeSummary',
            blocDataRequest: BD_MATCH_SPRING_ENDPOINT + '/engineapi/blocDataRequest',
            duplicateDetection: BD_MATCH_SPRING_ENDPOINT + '/engineapi/duplicateDetection',
            mergeAll: BD_MATCH_SPRING_ENDPOINT + '/engineapi/mergeAll',

            gcDataRequest: BD_MATCH_SPRING_ENDPOINT + '/engineapi/blocDataRequest/gc-manual-action',

            triggerReport: BD_MATCH_SPRING_ENDPOINT + '/engineapi/blocDataRequest/report',
        },
        enrich: {
            newAssets: ENRICH_SPRING_ENDPOINT + '/createAssetRequest',
            newAssetRequest: ENRICH_SPRING_ENDPOINT + '/newAssetRequest',
            updateAssets: ENRICH_SPRING_ENDPOINT + '/updateAssetRequest',
            deleteAsset: ENRICH_SPRING_ENDPOINT + '/deleteAssetRequest',
            refDataRequest: BD_ENRICH_SPRING_ENDPOINT + '/newRefDataRequest',
            refDataRequest360: BD_ENRICH_SPRING_ENDPOINT + '/newRefDataRequest360',
            createRefTrade: ENRICH_SPRING_ENDPOINT + '/createRefTradeRequest',
            newBlocDataRequest: BD_ENRICH_SPRING_ENDPOINT + '/newBlocDataRequest',
            newImportAssetRequestBulk: BD_ENRICH_SPRING_ENDPOINT + '/newImportAssetRequestBulk',
            reprocessSource: BD_ENRICH_SPRING_ENDPOINT + '/reprocessSource',
        },
    },
    infiniteTableProperties: {
        root: '/api/infinite-table-properties',
        tableMetaProperties: '/api/infinite-table-properties/table-meta-properties',
        tableInfiniteExtract: '/api/infinite-table-properties/table-infinite-extract',
        exportAll: 'api/infinite-table-properties/export-all-data',
        virtualColumns: '/api/infinite-table-properties/virtual-column',
        virtualColumnsData: '/api/infinite-table-properties/virtual-column/columns',
        moveFiles: '/api/infinite-table-properties/move-files',
        lastImportPath: '/api/infinite-table-properties/last-file-import',
        lastErroredImportPath: '/api/infinite-table-properties/last-errored-file-import',
        createFolder: '/api/infinite-table-properties/create-folder',
        showFiles: '/api/infinite-table-properties/show-files',
        downloadFiles: '/api/infinite-table-properties/download-files',
        uploadChunks: '/api/infinite-table-properties/upload/chunk',
        newAssetRequest: '/api/infinite-table-properties/enrich-engine',
        newEngineRequest: '/api/infinite-table-properties/matching-engine',
    },
    graphql: {
        root: '/api/explorer/audit-logging',
        getAllSchemas: '/api/explorer/audit-logging/schemas',
        audit: '/api/explorer/audit-logging/audit',
        reconGraph: '/api/explorer/audit-logging/recon-graph',
        simulation: '/api/explorer/audit-logging/simulation',
    },
    connectors: {
        connections: '/api/data-pipeline/adapter/connector',
        databases: '/api/data-pipeline/adapter/connector/databases',
        schemas: '/api/data-pipeline/adapter/connector/schemas',
        tables: '/api/data-pipeline/adapter/connector/tables',
        columns: '/api/data-pipeline/adapter/connector/columns',
    },
};
